import { render } from "./FacebookSso.vue?vue&type=template&id=1aee5d1a"
import script from "./FacebookSso.vue?vue&type=script&lang=js"
export * from "./FacebookSso.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__